/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */


app.controller('deprecated_dialog_editPositionCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', 'Notification', function ($rootScope, $scope, $http, NetworkService, MainService, Notification) {

        $(document).ready(function () {
            $("#positionImg").load(function () {
                $scope.loadImage()
            })
        })

        $rootScope.$on("render_dialog_editPositionCtrl", function () {
            MainService.setProfilePic("-1");
            $rootScope.$emit("setImage");

            $scope.position = MainService.getDialogData('dialog_editPositionCtrl')
            //$scope.positionAdminApproval = $scope.position.needs_approval
            $scope.position.specialFields = {pair: {value: false},
                leading: {value: false},
            hasTshirt: {value: false}}

            $scope.success = function (msg) {
                Notification.success(msg);
            };

            NetworkService.getSpecialFields($scope.position.position_id, function (data) {
                var specialFields = data.data
                specialFields.forEach(function (field) {
                    console.log(field)
                    if (field.type == 1)
                    {
                        $scope.position.specialFields.pair.value = true;
                    } else if (field.type == 2)
                    {
                        $scope.position.specialFields.leading.value = true;
                    }
                    else if (field.type == 3)
                    {
                        $scope.position.specialFields.hasTshirt.value = true;
                    }
                })
            })

            NetworkService.getPermissionForPosition($scope.position.position_id, function (data) {
                var groups = data.data
                $rootScope.$emit("setGroupMembers", groups)
            })
            $scope.img = "./imgs/positionImgs/position_" + $scope.position.position_id + ".png"


            if ($scope.position.needs_approval == 1)
            {
                $scope.positionAdminApproval = false
            } else
            {
                $scope.positionAdminApproval = true
            }

        })
function downloadFile(fileName, urlData) {

    var aLink = document.createElement('a');
    aLink.download = fileName;
    aLink.href = urlData;

    var event = new MouseEvent('click');
    aLink.dispatchEvent(event);
}


        $scope.generateEmailList = function()
        {
            //alert(JSON.stringify($scope.position))
            var position_id = $scope.position.position_id;
            NetworkService.generateEmailList(position_id,-1, function (data) {
                downloadFile('2.csv', 'data:text/csv;charset=UTF-8,' + '\uFEFF' + encodeURIComponent(data));
            })
        }
        $scope.removePosition = function ()
        {
            NetworkService.removePosition($scope.position.position_id, function (data) {
                $rootScope.$emit("repaint")
            })
        }
        $scope.openRemovePositionDialog = function ()
        {
            $("#dialog_agreePositionDelete").modal("open")()
        }
        $scope.loadImage = function ()
        {
            var picIsThere = false
            try
            {
                var img = $("#positionImg")[0]
                var canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                var ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                var dataURL = canvas.toDataURL("image/png");
                MainService.setProfilePic(dataURL);
                $rootScope.$emit("setImage");
            } catch (e)
            {
                console.log(e)
                MainService.setProfilePic("-1");
                $rootScope.$emit("setImage");
            }

        }




        $scope.updatePosition = function ()
        {
            if ($scope.positionAdminApproval)
            {
                $scope.position.needs_approval = 0
            } else
            {
                $scope.position.needs_approval = 1
            }
            var pic = MainService.getProfilePic()
            $scope.position.pic = pic
            NetworkService.updatePosition($scope.position, function (data) {
                $rootScope.$emit("repaint")
                $scope.success("Position upgedated");
            });

            var position_id = $scope.position.position_id;
            $rootScope.$emit("saveGroupMembers", position_id)
        }

    }])